<template>
  <div
    class="wrapper"
    v-on:touchstart="handleTouchStart"
    v-on:touchmove="handleTouchMove"
    v-on:touchend="handleTouchEnd"
  >
    <!-- Mobile Overlay -->
    <div
      class="sidebar-overlay"
      :class="{ 'show': isMobileSidebarOpen }"
      @click="closeSidebar"
    ></div>

    <!-- Sidebar -->
    <left-menu
      :is-collapsed="isDesktopCollapsed"
      :is-mobile-open="isMobileSidebarOpen"
      @close-mobile="closeSidebar"
    />

    <div class="main">
      <!-- Navbar -->
      <top-menu
        @toggle-sidebar="toggleSidebar"
      />

      <!-- Content -->
      <main class="content px-3 py-3">
        <div class="container-fluid">
          <license-banner />

          <div class="mb-3">
            <h3 v-if="$route.meta.title" class="text-dark">{{ $t($route.meta.title) }}</h3>

            <div class="card border-0 shadow-sm">
              <!-- แพ็กไม่มีฟีเจอร์ของหน้านี้ (เมนูซ่อนแล้ว แต่เข้าทาง URL / แท็บค้าง / แพ็กเปลี่ยนกลางคัน) -->
              <feature-not-available
                v-if="$route.meta.feature && !$hasFeature($route.meta.feature)"
                back-route="dashboards"
                back-text="_plan.Back to home"
              />
              <slot v-else />
            </div>
          </div>
        </div>
      </main>
    </div>

    <!-- ตั้งค่าเครื่องพิมพ์ของเครื่องนี้ — เปิดจากไอคอนแถบบน/การ์ดหน้าตั้งค่า (openPrinterSettings) -->
    <offcanvas-printer-settings
      v-if="printerUi.open"
      @closed="printerUi.open = false"
    />
  </div>
</template>

<script>
import LeftMenu from './admin/LeftMenu.vue';
import TopMenu from './admin/TopMenu.vue';
import LicenseBanner from '@/components/license/LicenseBanner.vue';
import FeatureNotAvailable from '@/plugins/FeatureNotAvailable.vue';
import OffcanvasPrinterSettings from '@/components/printer-settings/OffcanvasPrinterSettings.vue';
import { printerSettingsUi } from '@/utils/printerSettings';

export default {
  name: "Admin",
  components: {
    LeftMenu,
    TopMenu,
    LicenseBanner,
    FeatureNotAvailable,
    OffcanvasPrinterSettings
  },
  data() {
    return {
      printerUi: printerSettingsUi,
      isDesktopCollapsed: false,
      isMobileSidebarOpen: false,
      touchStartX: 0,
      touchEndX: 0,
      minSwipeDistance: 50 // Minimum distance in px to register a swipe
    }
  },
  watch: {
    // ล็อก scroll ของ body เมื่อเปิดเมนูบนมือถือ → กันเลื่อนทะลุไปโดน main ข้างหลัง
    isMobileSidebarOpen(open) {
      document.body.classList.toggle('sidebar-open-lock', open);
    }
  },
  mounted() {
    // Initial check for mobile
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
    document.body.classList.remove('sidebar-open-lock');
  },
  methods: {
    checkScreenSize() {
      if (window.innerWidth <= 768) {
        // Mobile mode: Default closed
        this.isMobileSidebarOpen = false;
        this.isDesktopCollapsed = false; // Reset desktop state
      } else {
        // Desktop mode: Reset mobile state
        this.isMobileSidebarOpen = false;
      }
    },
    toggleSidebar() {
      if (window.innerWidth <= 768) {
        this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
      } else {
        this.isDesktopCollapsed = !this.isDesktopCollapsed;
      }
    },
    closeSidebar() {
      this.isMobileSidebarOpen = false;
    },
    openSidebar() {
      this.isMobileSidebarOpen = true;
    },
    // --- Swipe Logic ---
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },
    handleTouchMove(e) {
      // Optional: Prevent scrolling while swiping sidebar if needed
    },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      this.checkSwipeDirection();
    },
    checkSwipeDirection() {
      const distance = this.touchEndX - this.touchStartX;
      const isMobile = window.innerWidth <= 768;

      if (!isMobile) return;

      // Swipe Right (Open) - Only if starting near left edge (optional refinement)
      if (distance > this.minSwipeDistance) {
        if (this.touchStartX < 50) {
           this.openSidebar();
        }
      }

      // Swipe Left (Close)
      if (distance < -this.minSwipeDistance) {
        if (this.isMobileSidebarOpen) {
          this.closeSidebar();
        }
      }
    }
  }
}
</script>
